export default "__VITE_PUBLIC_ASSET__5779934e__"